export const masterMessageGroupType = {
  crm: "CRMメッセージ",
  template: "テンプレート",
};
